import { NgModule } from '@angular/core';
import { BuDeleteComponent } from './bu-delete/bu-delete.component';

@NgModule({
  imports: [],
  declarations: [BuDeleteComponent],
  exports: [BuDeleteComponent]
})
export class BuDeleteModule { }
